import { Classifier } from "../../../util/classifierManager";
import { DateString } from "../../../util/conversionUtils";
import { SorterRequest } from "../../util/TableFunctionalityTypes";
import { ColumnHeader as DataColumns } from "./ContractWorkspaceDataTableTypes";
import { ColumnHeader as PaymentsColumns } from "./ContractWorkspacePaymentsTableTypes";

export enum InputName {
  lepinguKood = "lepinguKood",
  maakond = "maakond",
  vald = "vald",
  asutusuksus = "asutusuksus",
  lahiaadress = "lahiaadress",
  oiguslikAlus = "oiguslikAlus",
  kasutusviis = "kasutusviis",
  graafikuAlgus = "graafikuAlgus",
  graafikuLopp = "graafikuLopp",
  kasutajaKood = "kasutajaKood",
  kasutajaNimi = "kasutajaNimi",
  kodakondsus = "kodakondsus",
  isikuOlek = "isikuOlek",
  votjaPostiaadress = "votjaPostiaadress",
  kasutustasuTyyp = "kasutustasuTyyp",
  tasumiseSagedus = "tasumiseSagedus",
  maksegraafikuStaatus = "maksegraafikuStaatus",
  tasumataArveid = "tasumataArveid",
  tasumataNouded = "tasumataNouded",
}

export interface Input {
  [InputName.lepinguKood]?: string;
  [InputName.maakond]?: string;
  [InputName.vald]?: string;
  [InputName.asutusuksus]?: string;
  [InputName.lahiaadress]?: string;
  [InputName.oiguslikAlus]?: string;
  [InputName.kasutusviis]?: string;
  [InputName.graafikuAlgus]?: string;
  [InputName.graafikuLopp]?: string;
  [InputName.kasutajaKood]?: string;
  [InputName.kasutajaNimi]?: string;
  [InputName.kodakondsus]?: string;
  [InputName.isikuOlek]?: string;
  [InputName.votjaPostiaadress]?: string;
  [InputName.kasutustasuTyyp]?: string;
  [InputName.tasumiseSagedus]?: string;
  [InputName.maksegraafikuStaatus]?: string;
  [InputName.tasumataArveid]?: string;
  [InputName.tasumataNouded]?: string;
}

export enum InputNamePayments {
  lepinguKood = "lepinguKood",
  maakond = "maakond",
  vald = "vald",
  asutusuksus = "asutusuksus",
  lahiaadress = "lahiaadress",
  graafikuAlgus = "graafikuAlgus",
  graafikuLopp = "graafikuLopp",
  kasutajaKood = "kasutajaKood",
  kasutajaNimi = "kasutajaNimi",
  kodakondsus = "kodakondsus",
  isikuOlek = "isikuOlek",
  kasutustasuTyyp = "kasutustasuTyyp",
  tasumiseSagedus = "tasumiseSagedus",
  maksegraafikuStaatus = "maksegraafikuStaatus",
  tasuPeriood = "tasuPeriood",
  maksetahtaeg = "maksetahtaeg",
  makseSumma = "makseSumma",
  makseStaatus = "makseStaatus",
  kontrolliKpv = "kontrolliKpv",
  markus = "markus",
}

export interface InputPayments {
  [InputNamePayments.lepinguKood]?: string;
  [InputNamePayments.maakond]?: string;
  [InputNamePayments.vald]?: string;
  [InputNamePayments.asutusuksus]?: string;
  [InputNamePayments.lahiaadress]?: string;
  [InputNamePayments.graafikuAlgus]?: string;
  [InputNamePayments.graafikuLopp]?: string;
  [InputNamePayments.kasutajaKood]?: string;
  [InputNamePayments.kasutajaNimi]?: string;
  [InputNamePayments.kodakondsus]?: string;
  [InputNamePayments.isikuOlek]?: string;
  [InputNamePayments.kasutustasuTyyp]?: string;
  [InputNamePayments.tasumiseSagedus]?: string;
  [InputNamePayments.maksegraafikuStaatus]?: string;
  [InputNamePayments.tasuPeriood]?: string;
  [InputNamePayments.maksetahtaeg]?: string;
  [InputNamePayments.makseSumma]?: string;
  [InputNamePayments.makseStaatus]?: string;
  [InputNamePayments.kontrolliKpv]?: string;
  [InputNamePayments.markus]?: string;
}

export enum InputNameFilters {
  aadressString = "aadressString",
  aadress = "aadress",
  aadressString_2 = "aadressString_2",
  oiguslikAlus = "oiguslikAlus",
  kasutusviis = "kasutusviis",
  graafikuAlgusStartDate = "graafikuAlgusStartDate",
  graafikuAlgusEndDate = "graafikuAlgusEndDate",
  graafikuAlgusPuudu = "graafikuAlgusPuudu",
  graafikuLoppStartDate = "graafikuLoppStartDate",
  graafikuLoppEndDate = "graafikuLoppEndDate",
  graafikuLoppPuudu = "graafikuLoppPuudu",
  kasutajaKood = "kasutajaKood",
  kasutajaNimi = "kasutajaNimi",
  kodakondsus = "kodakondsus",
  isikuOlek = "isikuOlek",
  kasutustasuTyyp = "kasutustasuTyyp",
  tasumiseSagedus = "tasumiseSagedus",
  maksegraafikuStaatus = "maksegraafikuStaatus",
  tasumataArveid = "tasumataArveid",
  tootlemiseStaatus = "tootlemiseStaatus",
  tahtaegStartDate = "tahtaegStartDate",
  tahtaegEndDate = "tahtaegEndDate",
  makseStaatus = "makseStaatus",
  kontrolliKpvStartDate = "kontrolliKpvStartDate",
  kontrolliKpvEndDate = "kontrolliKpvEndDate",
  kontrolliKpvPuudu = "kontrolliKpvPuudu",
}

export type InputFieldName =
  | InputNameFilters.aadressString
  | InputNameFilters.aadress
  | InputNameFilters.aadressString_2
  | InputNameFilters.graafikuAlgusStartDate
  | InputNameFilters.graafikuAlgusEndDate
  | InputNameFilters.graafikuAlgusPuudu
  | InputNameFilters.graafikuLoppStartDate
  | InputNameFilters.graafikuLoppEndDate
  | InputNameFilters.graafikuLoppPuudu
  | InputNameFilters.kasutajaKood
  | InputNameFilters.kasutajaNimi
  | InputNameFilters.tahtaegStartDate
  | InputNameFilters.tahtaegEndDate
  | InputNameFilters.kontrolliKpvStartDate
  | InputNameFilters.kontrolliKpvEndDate;

export type SelectFieldName =
  | InputNameFilters.oiguslikAlus
  | InputNameFilters.kasutusviis
  | InputNameFilters.kodakondsus
  | InputNameFilters.isikuOlek
  | InputNameFilters.kasutustasuTyyp
  | InputNameFilters.tasumiseSagedus
  | InputNameFilters.maksegraafikuStaatus
  | InputNameFilters.tasumataArveid
  | InputNameFilters.tootlemiseStaatus
  | InputNameFilters.makseStaatus;

export interface InputFilters extends DataFilters, PaymentFilters {}

export type ErrorInputFilters = Partial<Record<keyof InputFilters, string>>;

export interface DataFilters {
  [InputNameFilters.aadressString]?: string;
  [InputNameFilters.aadress]?: AddressPart;
  [InputNameFilters.aadressString_2]?: string;
  [InputNameFilters.graafikuAlgusStartDate]?: DateString;
  [InputNameFilters.graafikuAlgusEndDate]?: DateString;
  [InputNameFilters.graafikuAlgusPuudu]?: boolean;
  [InputNameFilters.graafikuLoppStartDate]?: DateString;
  [InputNameFilters.graafikuLoppEndDate]?: DateString;
  [InputNameFilters.graafikuLoppPuudu]?: boolean;
  [InputNameFilters.kasutajaKood]?: string;
  [InputNameFilters.kasutajaNimi]?: string;
  [InputNameFilters.kodakondsus]?: Classifier;
  [InputNameFilters.isikuOlek]?: Classifier;
  [InputNameFilters.kasutustasuTyyp]?: Classifier;
  [InputNameFilters.tasumiseSagedus]?: Classifier;
  [InputNameFilters.maksegraafikuStaatus]?: Classifier;
  [InputNameFilters.oiguslikAlus]?: Classifier;
  [InputNameFilters.kasutusviis]?: Classifier;
  [InputNameFilters.tasumataArveid]?: Classifier;
  [InputNameFilters.tootlemiseStaatus]?: Classifier;
}

export interface PaymentFilters {
  [InputNameFilters.aadressString]?: string;
  [InputNameFilters.aadress]?: AddressPart;
  [InputNameFilters.aadressString_2]?: string;
  [InputNameFilters.graafikuAlgusStartDate]?: DateString;
  [InputNameFilters.graafikuAlgusEndDate]?: DateString;
  [InputNameFilters.graafikuAlgusPuudu]?: boolean;
  [InputNameFilters.graafikuLoppStartDate]?: DateString;
  [InputNameFilters.graafikuLoppEndDate]?: DateString;
  [InputNameFilters.graafikuLoppPuudu]?: boolean;
  [InputNameFilters.kasutajaKood]?: string;
  [InputNameFilters.kasutajaNimi]?: string;
  [InputNameFilters.kodakondsus]?: Classifier;
  [InputNameFilters.isikuOlek]?: Classifier;
  [InputNameFilters.kasutustasuTyyp]?: Classifier;
  [InputNameFilters.tasumiseSagedus]?: Classifier;
  [InputNameFilters.maksegraafikuStaatus]?: Classifier;
  [InputNameFilters.tahtaegStartDate]?: DateString;
  [InputNameFilters.tahtaegEndDate]?: DateString;
  [InputNameFilters.makseStaatus]?: Classifier;
  [InputNameFilters.kontrolliKpvStartDate]?: DateString;
  [InputNameFilters.kontrolliKpvEndDate]?: DateString;
  [InputNameFilters.kontrolliKpvPuudu]?: boolean;
}

export interface Filters {
  dataFilters: DataFilters;
  paymentFilters: PaymentFilters;
}

export interface AddressPart {
  aadressiTyyp: string;
  aadressTekst?: string;
  maakondKood?: string;
  valdKood?: string;
  kylaKood?: string;
  lahiaadress?: string;
}

export enum ProcessingStatus {
  PROCESSED = "TOODELDUD",
  UNPROCESSED = "TOOTLEMATA",
  FAULTY = "VIGANE",
}

export interface Sorting {
  dataSorting: SorterRequest<DataColumns>;
  paymentsSorting: SorterRequest<PaymentsColumns>;
}

interface pagination {
  offset: number;
  limit: number;
}

export interface Pagination {
  dataPagination: pagination;
  paymentsPagination: pagination;
}

export type RangePickerProps = {
  labelName: string;
  start: InputNameFilters;
  end: InputNameFilters;
  startValue?: DateString;
  endValue?: DateString;
  startRequired?: boolean;
  isInsertNull?: boolean;
  isNull?: boolean;
  isFormSubmitted?: boolean;
};

export enum SubmitType {
  SEARCH = "SEARCH",
  CSV_EXPORT = "CSV_EXPORT",
}
